import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useFinancialStore } from '../store/useFinancialStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading } = useFinancialStore();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center bg-bg-primary">
        <div className="relative group">
           <div className="absolute inset-0 bg-brand-teal/20 blur-xl rounded-full scale-110" />
           <div className="w-16 h-16 border-4 border-brand-teal/20 border-t-brand-teal rounded-full animate-spin shadow-glow relative z-10" />
        </div>
      </div>
    );
  }

  if (!user) {
    // Redirect to login but save the current location to redirect back after login
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
